module.exports = __webpack_public_path__ + "7d4d6d74b09a678983e28bdb4813c454.svg";